import { useMemo } from 'react'
import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { HubspotWorkflowsPageStore } from 'pages/hubspotWorkflows/store/HubspotWorkflowsPageStore'
import { HubspotWorkflowsPageContext } from 'pages/hubspotWorkflows/context/hubspotWorkflowsPageContext'

export const HubspotWorkflowsPageLayout = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const pageStore = useMemo(
    () => new HubspotWorkflowsPageStore(menuLayoutStore.pageLayoutStore),
    []
  )

  return (
    <HubspotWorkflowsPageContext.Provider value={pageStore}>
      <Outlet />
    </HubspotWorkflowsPageContext.Provider>
  )
})
